import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'core-js/features/array/find'
import 'core-js/features/array/includes'
import 'core-js/features/number/is-nan'

if (!String.prototype.startsWith) {
  // eslint-disable-next-line
  String.prototype.startsWith = function(searchString, position) {
    position = position || 0
    return this.substr(position, searchString.length) === searchString
  }
}
